import React, { Component } from "react";
import PropTypes from "prop-types";
import { observable } from "mobx";
import { observer } from "mobx-react";
import LoadingWrapper from "~/components/wrapper/LoadingWrapper";
import UserStore from "~/stores/UserStore";
import User from "~/models/User";

@observer
class LoggedInUserWrapper extends Component {
  @observable userStore = null;

  constructor(props) {
    super(props);
    this.userStore = new UserStore();
  }

  componentDidMount() {
    this.userStore.load().catch(() => {
      // Empty User if not logged in
      this.userStore.user = new User({});
      this.userStore.isLoaded = true;
    });
  }

  render() {
    const { children } = this.props;
    const { user } = this.userStore;

    if (!this.userStore.isLoaded) {
      return <LoadingWrapper loading />;
    }

    return children(user, this.userStore);
  }
}

LoggedInUserWrapper.propTypes = {
  children: PropTypes.func.isRequired,
};

export default LoggedInUserWrapper;
